import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-pages-nav-page',
  standalone: false,
  templateUrl: './pages-nav-page.component.html',
  styleUrl: './pages-nav-page.component.css'
})
export class PagesNavPageComponent {
  menuItems = [
    { path: "addPage", label: "Add New Page", icon: "pi pi-plus" },
    { path: "showPages", label: "Manage", icon: "pi pi-cog" },
  ];

  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "addPage": "pi pi-plus",  
      "showPages": "pi pi-cog", 
    };
    return iconMap[path] || "bi bi-circle"; 
  }

  userRole: string;

  constructor(private auth: AuthService) {
    this.userRole = this.auth.getRoles();
  }
}
